/* reducer is used in client area */
import { FETCH_METRO_AREAS,USER_LOGOUT, FETCH_METRO_AREA, UPDATE_METRO_AREA, ADD_METRO_AREA,DELETE_METRO_AREA }  from"actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_METRO_AREAS:
         //   console.log(FETCH_METRO_AREAS, action.payload);
            return {
                data: action.payload.data,
                fetched:true
            }
        case FETCH_METRO_AREA:
        //    console.log('FETCH_METRO_AREA', state, action.payload.data);
            return {
                ...state,
                data: _.concat(state.data, action.payload.data),
             }
        case UPDATE_METRO_AREA:
            console.log(`UPDATE_METRO_AREA${action.payload}`);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload._id});
            return {
                ...state,
                data: [...state.data.slice(0, itemIndex),
                    action.payload,
                    ...state.data.slice(itemIndex + 1)]
            }
        case ADD_METRO_AREA:
            console.log("ADD_METRO_AREA", action);
            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
            }
        case DELETE_METRO_AREA:
            console.log(`DELETE_METRO_AREA${action.payload}`);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload.MetroAreaID});
            return {
                ...state,
                data: [...state.data.slice(0, itemIndex),
                    ...state.data.slice(itemIndex + 1)],
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
export const getMetroArea = (state, id) => {
    return state.metroAreas.data.filter(record => record._id === id)[0];
}